<script setup lang="ts">
import type {DialogDescriptionProps} from 'reka-ui'
import type {HTMLAttributes} from 'vue'
import {reactiveOmit} from '@vueuse/core'
import {DialogDescription, useForwardProps} from 'reka-ui'
import {cn} from '@/lib/utils'

const props = defineProps<DialogDescriptionProps & {class?: HTMLAttributes['class']}>()

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DialogDescription v-bind="forwardedProps" :class="cn('text-sm text-muted-foreground', props.class)">
    <slot />
  </DialogDescription>
</template>
